export default "__VITE_ASSET__D223hVcQ__"